import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ContactUs from '../components/ContactUs';
import Gallery from '../components/Gallery';
import { Link } from 'gatsby';

const img_set = [
  {
    src: require('../assets/images/portfolio/fullsize/16.jpg'),
    thumbnail: require('../assets/images/portfolio/thumbnails/16.jpg'),
  },
  {
    src: require('../assets/images/portfolio/fullsize/11.jpg'),
    thumbnail: require('../assets/images/portfolio/thumbnails/11.jpg'),
  },
  {
    src: require('../assets/images/portfolio/fullsize/12.jpg'),
    thumbnail: require('../assets/images/portfolio/thumbnails/12.jpg'),
  },
  {
    src: require('../assets/images/portfolio/fullsize/13.jpg'),
    thumbnail: require('../assets/images/portfolio/thumbnails/13.jpg'),
  },
  {
    src: require('../assets/images/portfolio/fullsize/14.jpg'),
    thumbnail: require('../assets/images/portfolio/thumbnails/14.jpg'),
  },
  {
    src: require('../assets/images/portfolio/fullsize/10.jpg'),
    thumbnail: require('../assets/images/portfolio/thumbnails/10.jpg'),
  },
  {
    src: require('../assets/images/portfolio/fullsize/15.jpg'),
    thumbnail: require('../assets/images/portfolio/thumbnails/15.jpg'),
  },
];

const services = [
  {
    icon: 'fa-paint-brush',
    title: 'Malen & Spritzen',
    short:
      'Malen ist mehr, als nur Farbe an die Wand. Ob Innenräume, Fassaden oder Kleinobjekte – ich prüfe Oberflächen und biete ökonomisch und ökologisch sinnvolle Lösungen. Bei Fenstern und Heizkörpern ist Spritzen effizienter als Streichen.',
    long: 'Ich helfe Ihnen, die richtige Farbe zu finden und bringe sie professionell an die Wand – gestrichen oder gespritzt.',
  },
  {
    icon: 'fa-image',
    title: 'Tapezieren',
    short:
      'Von klassischen Mustern bis zu magnetischen und heu-basierten Öko-Tapeten – die Auswahl ist riesig. Wasserfeste Tapeten für Nassbereiche, Fototapeten oder edle Textiltapeten.',
    long: 'Von der Beratung bis zum fertigen Ergebnis – ich tapeziere fachgerecht und sauber.',
  },
  {
    icon: 'fa-home',
    title: 'Fassaden',
    short:
      'Regen, Sonne, Wind, Kälte – Fassaden müssen hart im Nehmen sein. Das richtige Farbprodukt verbessert den Schutz entscheidend und braucht fundiertes Fachwissen.',
    long: 'Ich schaue mir Ihre Fassade an und empfehle das richtige Produkt – für langfristigen Schutz und gute Optik.',
  },
  {
    icon: 'fa-gem',
    title: 'Mineralverputze',
    short:
      'Kalk- und Lehmverputze schaffen ein gesundes Wohnklima – atmungsaktiv und ökologisch. Siliconharzputze als Alternative bieten mehr Farbwahl und Robustheit.',
    long: 'Kommen Sie vorbei oder rufen Sie an – ich berate Sie gerne zum passenden Putz für Ihr Zuhause.',
  },
  {
    icon: 'fa-heart',
    title: 'Dekorative Techniken',
    short:
      'Valpaint, Stucco Marmorino, Stucco Antico – Spachteltechniken, die Räume sinnlich und einzigartig machen. Auch alte oder moderne Schriftzüge als individueller Akzent.',
    long: 'Bringen Sie Ihre Ideen mit – ich setze sie um, damit Ihr Raum genau wird, wie Sie ihn möchten.',
  },
  {
    icon: 'fa-plus-circle',
    title: 'Weitere Angebote',
    short:
      'Schimmelpilzsanierung, Whiteboard- und Magnetbeschichtungen für Büros und Kinderzimmer – professionelle Lösungen für besondere Anforderungen.',
    long: 'Ich komme vorbei und schaue mir die Situation an – dann besprechen wir die passenden Massnahmen.',
  },
];

const IndexPage = () => (
  <Layout>
    <Header />

    <header className="masthead">
      <div className="container h-100">
        <div className="row h-100 align-items-center justify-content-center text-center">
          <div className="col-lg-10 align-self-end">
             <h1 className="text-white-75 font-weight-light mb-2">Maler in Savognin, Val Surses</h1>
             <h2 className="text-uppercase text-white font-weight-bold">
               {config.heading}
             </h2>
            <hr className="divider my-4" />
          </div>
          <div className="col-lg-8 align-self-baseline">
            <p className="text-white-75 font-weight-light mb-5">
              {config.subHeading}
            </p>
            <Scroll type="id" element="services">
              <a
                className="btn btn-primary btn-xl js-scroll-trigger"
                href="#services"
              >
                Angebote ansehen
              </a>
            </Scroll>
          </div>
        </div>
      </div>
    </header>

    <section className="page-section bg-primary" id="partner">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center" style={{ marginTop: 25 }}>
            <h2 className="text-white mt-0">Malerarbeiten, die passen</h2>
            <hr className="divider light my-4" />
            <p className="text-white-90 mb-0">
              Neue Farbe im Wohnzimmer? Fassade braucht einen Anstrich? Oder ein 
              Tapezier-Profi, der mal richtig durchzieht? Ich mach das.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="page-section bg-dark text-white" id="about-intro">
      <div className="container text-center">
        <h2 className="mb-4">Über mich</h2>
        <p className="text-white-90 mb-4 mx-auto" style={{ maxWidth: 600 }}>
          Ricardo Wasescha – gelernter Maler EFZ, seit 2020 selbstständig. Tätig in Savognin und im ganzen Val Surses – mit Erfahrung aus Zürich und Winterthur.
        </p>
        <Link className="btn btn-outline-light btn-xl" to={'/über-mich'}>
          Mehr erfahren
        </Link>
      </div>
    </section>

    <section className="page-section" id="services">
      <div className="container">
        <h2 className="text-center mt-0">Was ich anbiete</h2>
        <hr className="divider my-4" />
        <div className="row">
          {services.map((svc, i) => (
            <div key={i} className="col-lg-4 col-md-6 text-center">
              <div className="mt-5 service-card">
                <i className={`fas fa-4x ${svc.icon} text-primary mb-3`}></i>
                <h3 className="h4 mb-2">{svc.title}</h3>
                <p className="text-muted mb-2">{svc.short}</p>
                <p className="text-muted small">{svc.long}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section id="portfolio">
      <Gallery images={img_set} />
    </section>

    <ContactUs />

    <Footer />
  </Layout>
);

export default IndexPage;